import React, { Fragment } from 'react';
import styled from 'styled-components';
import _ from 'lodash';
import numberFormatter from 'utils/numberFormatter';
import { Grid, Button } from "@material-ui/core";
import {
  ResultErrorContainer
  , BlueResult
  , CenterAlignedValue
  , WhiteBackground
  , BigText
  , CenterAlignedLabel
  , FancyDividerBlack
  , FancyDividerGray
  , PrimaryDataWrapper
  , AddRow
  , CenteredVerticalSpace
  , CenterAlignedGrid
  , LeftAlignedGrid
  , RightAlignedGrid
  , AdditionalInformationWrapper
  , FlexContainer
} from '../styles'

const Disclosure = styled.div`
  && {
    font-size:13px;
  }
`

const ResultContainer = styled.div`
  && {
    padding-right:5px;
  }
`
const PrimaryData = ({ value, label }) => {
  return (
    <CenteredVerticalSpace>
      <CenterAlignedValue>{value}</CenterAlignedValue>
      <CenterAlignedLabel>{label}</CenterAlignedLabel>
    </CenteredVerticalSpace>
  )
}

class AnalysisResult extends React.Component {
  state = { showGrid: false }

  formatCalculatedValues = (type, value, column) => {
    if (!value) return "--";
    if (type === "DSCR_CHECK")
      return column === "DSCR" ? `${numberFormatter.formatDecimal(value, 2)}x` : numberFormatter.formatRate(value, 0);
    else
      return numberFormatter.formatMoney(value, 2);
  }
  formatCalculatedValuesTypes = (type) => {
    switch (type) {
      case "PROCEEDS":
        return "Proceeds";
      case "PMT":
        return "PMT";
      case "ANNUAL_DEBT_SERVICE":
        return "Annual Debt Service";
      case "DSCR_CHECK":
        return "Constraints";
      default:
        return "N/A";
    }
  }

  render() {
    const { cashOutResult, loanProceeds } = this.props;

    if (_.isEmpty(loanProceeds))
      return null;

    if (!cashOutResult || !loanProceeds)
      return (<ResultErrorContainer><p>We were not able to calculate your Loan Proceeds.</p>
        <p>Please check your inputs.</p></ResultErrorContainer>);
    else
      return (
        <ResultContainer>
          <div direction="right" style={{ zIndex: 5 }} hidden={this.state.showGrid}>
            <BlueResult>
              <PrimaryDataWrapper>
                <WhiteBackground>
                  <BigText>{numberFormatter.formatMoney(cashOutResult.cashOut, 0, "--")}</BigText>
                  <CenterAlignedLabel>Refi Cash Out</CenterAlignedLabel>
                </WhiteBackground>
                <AddRow><PrimaryData value={numberFormatter.formatMoney(cashOutResult.loanProceeds, 2, "--")} label='Loan Proceeds' /></AddRow>
                <AddRow><PrimaryData value={numberFormatter.formatMoney(cashOutResult.currentBalance, 2, "--")} label='Current Balance' /></AddRow>
                <AddRow><PrimaryData value={numberFormatter.formatMoney(cashOutResult.prepaymentPenalty, 2, "--")} label='Prepayment Penalty' /></AddRow>
              </PrimaryDataWrapper>
            </BlueResult>
          </div>
          <div direction="left" style={{ zIndex: 5 }} hidden={!this.state.showGrid}>
            <AdditionalInformationWrapper>
              <FlexContainer>
                <Grid container justify="space-between" direction="row">
                  <CenterAlignedGrid item xs={3}></CenterAlignedGrid>
                  <CenterAlignedGrid item xs={3}>DSCR</CenterAlignedGrid>
                  <CenterAlignedGrid item xs={3}>LTV</CenterAlignedGrid>
                  <CenterAlignedGrid item xs={3}>Debt Yield</CenterAlignedGrid>
                  <Grid item xs={12}><FancyDividerBlack /></Grid>
                  {loanProceeds.loanProceedsCalculatedValues.map(row => {
                    return (<Fragment>
                      <LeftAlignedGrid item xs={3}>{this.formatCalculatedValuesTypes(row.type)}</LeftAlignedGrid>
                      <RightAlignedGrid item xs={3}>{this.formatCalculatedValues(row.type, row.maxProceedsDSCR, "DSCR")}</RightAlignedGrid>
                      <RightAlignedGrid item xs={3}>{this.formatCalculatedValues(row.type, row.maxLTV, "LTV")}</RightAlignedGrid>
                      <RightAlignedGrid item xs={3}>{this.formatCalculatedValues(row.type, row.maxDebtYield, "DebtYield")}</RightAlignedGrid>
                      <Grid item xs={12}><FancyDividerGray /></Grid>
                    </Fragment>);
                  })}
                </Grid>
              </FlexContainer>
            </AdditionalInformationWrapper>
          </div>
          <Button onClick={() => { this.setState({ showGrid: !this.state.showGrid }) }}>{this.state.showGrid ? "Hide" : "Show"} Additional information</Button>
          <Disclosure>Calculations are for informational purposes and subject to change with market conditions.</Disclosure>
        </ResultContainer>
      )
  };
}
export default AnalysisResult;
